import { HttpResponse } from 'msw';

type LegacyBody = { command?: string; access?: string };

export function handleSnmpLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  const access = body.access ?? 'get';

  switch (access) {
    case 'get':
      switch (command) {
        case 'get config':
          return HttpResponse.json(
            {
              v1: true,
              v2c: true,
              v3: true,
              read_community: 'public',
              write_community: 'private',
              engineID: '0x80001f8880e9630001',
            },
            { status: 200 },
          );
        case 'get user':
          return HttpResponse.json([{ name: 'admin' }, { name: 'operator' }], {
            status: 200,
          });
        default:
          return HttpResponse.json(
            {
              error: 'not implemented',
              msg: `Mock missing for snmp:${command}`,
            },
            { status: 400 },
          );
      }
    case 'set':
      return HttpResponse.json({ ok: true }, { status: 200 });
    default:
      return HttpResponse.json(
        {
          error: 'not implemented',
          msg: `Mock missing for snmp access:${access}`,
        },
        { status: 400 },
      );
  }
}

export function handleTrapLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  const access = body.access ?? 'get';

  switch (access) {
    case 'get':
      if (command === 'get trap') {
        return HttpResponse.json(
          { enabled: false, destination: '', community: 'public' },
          { status: 200 },
        );
      }
      return HttpResponse.json(
        { error: 'not implemented', msg: `Mock missing for trap:${command}` },
        { status: 400 },
      );
    case 'set':
      return HttpResponse.json({ ok: true }, { status: 200 });
    default:
      return HttpResponse.json(
        {
          error: 'not implemented',
          msg: `Mock missing for trap access:${access}`,
        },
        { status: 400 },
      );
  }
}

export function handleNatLegacy(
  body: LegacyBody,
): ReturnType<typeof HttpResponse.json> {
  const command = body.command ?? '';
  switch (command) {
    case 'state':
      return HttpResponse.json({ enabled: true }, { status: 200 });
    case 'rule': {
      const access = body.access ?? 'get';
      switch (access) {
        case 'get':
          return HttpResponse.json(
            [
              { name: '1:1 NAT 203.0.113.10 to 192.168.1.10' },
              { name: 'PAT TCP 203.0.113.10:8080 to 192.168.1.50:80' },
            ],
            { status: 200 },
          );
        case 'set':
        case 'add':
        case 'remove':
          return HttpResponse.json({ ok: true }, { status: 200 });
        default:
          return HttpResponse.json(
            {
              error: 'not implemented',
              msg: `Mock missing for nat rule access:${access}`,
            },
            { status: 400 },
          );
      }
    }
    default:
      return HttpResponse.json(
        { error: 'not implemented', msg: `Mock missing for nat:${command}` },
        { status: 400 },
      );
  }
}
